import useStringUtils from 'hooks/useStringUtils'

function DoctorDetails({ data }) {
    const { formatAddress } = useStringUtils()

    const practice = data.request.practice
    const doctor = data.request.doctor
    const address = formatAddress(practice)

    return (
        <>
            <h3>Doctor Details</h3>
            <span>Dr. {doctor.fullName}</span>
            <span>Address: {address}</span>
            <span>Phone: {practice.phone}</span>
            <span>Email: {practice.email}</span>
            <span>MCRN: {doctor.medCouncilNo}</span>
        </>
    )
}

export default DoctorDetails